<template>
  <b-modal
    hide-footer
    id="modal-fasttrack-history"
    ref="modal-fasttrack-history"
    size="lg"
    title="ประวัติสถานะ"
  >
    <div v-if="fasttrackHistoryDetail.length > 0">
      <b-row
        v-for="trackingItem in fasttrackHistoryDetail"
        :key="trackingItem.trackingId"
      >        

        <b-col cols="12" class="list-group list-group-circle text-left m-1">
          <div class="d-flex list-group-item">
            <div class="">
              <h5 class="mb-0">
                {{ 1 }}. {{ trackingItem.companyName }}
                </span>
              </h5>
              <!-- <small class="text-muted">{{ item.createTracking }}</small> -->
            </div>
            <div class="col ml-auto">
              <hr class="my-12 bg-dark" />
            </div>
          </div>

          <div
            v-for="(item, index) in trackingItem.trackingComplaintDetails"
          :key="item.trackingDetailId"
            class="d-flex justify-content-round ml-2 mr-5"
          >
            <div
              
              class="w-100"
            >
              
              <div class="d-flex justify-content-between ml-2">
                <span class="mb-0">
                  {{ index + 1 }} ) {{ item.levelName }} :
                  <span >
                    {{ item.statusName }}

                  </span>
                </span>
              </div>

              <div class="d-flex justify-content-between ml-2 text-left">
                <small class="mb-0"> {{ item.createTrackingStr }}</small>
                <small                  
                  class="d-flex justify-content-between ml-2"
                >
                  <span >
                    <b> {{ item.userActiveFullname ? item.userActiveFullname : '-' }}</b>

                  </span>
                </small>
              </div>

              <div
                class="d-flex justify-content-between ml-2"
                v-if="item.comment"
              >
                <span class="mb-0">
                  <b> ความคิดเห็น : </b> {{ item.comment }}
                </span>
              </div>

              

              <hr class="my-12 bg-dark w-100" />
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- <b-row v-if="fasttrackHistoryDetail.length > 0">
      <b-col>
        <div class="d-flex justify-content-between ml-1 mt-1 text-center">
          <span>
            <b-button
              variant="outline-primary"
              @click="
                getSuccess(fasttrackHistoryDetail[0].documentTracking.docId)
              "
            >
              ดูเอกสารคำขอ
            </b-button>
          </span>
        </div>
      </b-col>
    </b-row> -->
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BModal,
  BButton,
  BFormTextarea,
  BCard,
} from "bootstrap-vue";

import appsettings from "@/store/app-settings";
import * as userData from "@/auth/localStorageUtils.js";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BFormTextarea,
    BCard,
  },
  props: {
    fasttrackHistoryDetail: [],
  },
  data() {
    return {};
  },
  created() {
    console.log(this.fasttrackHistoryDetail);
  },
  mounted() {
    //console.log("modal mounted");
  },
  methods: {
    getSuccess(docId) {
      // let redirectUrl =
      //   location.origin + this.$router.resolve({ name: "Approve" }).href;
      // let redirectBack =
      //   location.origin + this.$router.resolve({ name: "Approve" }).href;

      let redirectUrl = location.origin + this.$router.currentRoute.fullPath;

      const documentUrl = appsettings.documentUrl
        .replace("{0}", docId)
        .replace("{1}", userData.userId())
        .replace("{2}", redirectUrl)
        .replace("{3}", redirectUrl);

      //window.location.href = documentUrl;

      window.open(documentUrl, "_blank");
    },
  },
};
</script>

<style></style>
